module.exports = __webpack_public_path__ + "img/Antique.a07cd54.jpg";